<template>
    <component :is="component" v-for="component in components" :key="component" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

/**
 * Renders module components registered into an admin layout slot via the
 * server-side app('layout.components') registry (shared as the
 * `layoutComponents` Inertia prop). Component names must be globally
 * registered — modules do that in their `src/{Module}/index.ts` setup().
 */
const props = defineProps<{ name: string }>();

const components = computed(() => {
    const slots = usePage().props.layoutComponents as Record<string, string[]> | undefined;

    return slots?.[props.name] ?? [];
});
</script>
